export enum HomeDeliveryAddressKey {
    EndConsumersHomeDeliveryAddresses = "EndConsumersHomeDeliveryAddresses",
    HomeDeliveryAddresses = "HomeDeliveryAddresses",
}
